export default function getCookieFromQueryString(
	qs: string,
): string | undefined {
	return qs.split("jam_filled_cookie=")[1].split("&")[0]
}
